import { ReactComponent as HKDCIconSVG } from "./hkdc-icon.svg";
import { SvgIcon } from '@mui/material';

export default function IconHKDC(props) {
  return <SvgIcon {...props} component={HKDCIconSVG} viewBox="0 0 84 48" />;
}